import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CREDENCIADOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterTodas(filtro) {
        return axiosJwt
            .get(
                `${api}/credenciados/fornecedores/finalizacoes?dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(finalizacaoId) {
        return axiosJwt
            .get(
                `${api}/credenciados/fornecedores/finalizacoes/${finalizacaoId}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterEntregasDisponiveis(finalizacaoId) {
        return axiosJwt
            .get(
                `${api}/credenciados/fornecedores/finalizacoes/${finalizacaoId}/entregasdisponiveis`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    associarEntregas(finalizacaoEntregas) {
        return axiosJwt
            .post(
                `${api}/credenciados/fornecedores/finalizacoes/${finalizacaoEntregas.finalizacaoId}/associarentregas`,
                finalizacaoEntregas
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    desassociarEntrega(finalizacaoEntrega) {
        return axiosJwt
            .post(
                `${api}/credenciados/fornecedores/finalizacoes/${finalizacaoEntrega.finalizacaoId}/desassociarentrega`,
                finalizacaoEntrega
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirFinalizacao() {
        return axiosJwt
            .post(`${api}/credenciados/fornecedores/finalizacoes`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexosTipos() {
        return axiosJwt
            .get(`${api}/credenciados/fornecedores/finalizacoes/anexos/tipos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirFinalizacaoAnexo(finalizacaoAnexo) {
        const formData = new FormData()
        formData.append('finalizacaoId', finalizacaoAnexo.finalizacaoId)
        formData.append('tipoId', finalizacaoAnexo.tipoId)
        formData.append('descritivo', finalizacaoAnexo.descritivo)
        formData.append('arquivo', finalizacaoAnexo.arquivo)

        return axiosJwt
            .post(
                `${api}/credenciados/fornecedores/finalizacoes/${finalizacaoAnexo.finalizacaoId}/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAnexo(finalizacaoAnexo) {
        return axiosJwt
            .put(
                `${api}/credenciados/fornecedores/finalizacoes/${finalizacaoAnexo.finalizacaoId}/anexos`,
                finalizacaoAnexo
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    enviarFinalizacaoParaAprovacao(finalizacaoParaAprovacao) {
        return axiosJwt
            .post(
                `${api}/credenciados/fornecedores/finalizacoes/enviar`,
                finalizacaoParaAprovacao
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterFinalizacaoAnexo(finalizacaoAnexoId) {
        return axiosJwt
            .get(
                `${api}/credenciados/fornecedores/finalizacoes/anexos/${finalizacaoAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterDespViagensDisponiveis(finalizacaoId) {
        return axiosJwt
            .get(
                `${api}/credenciados/fornecedores/finalizacoes/${finalizacaoId}/despviagensdisponiveis`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    associarDespViagens(finalizacaoDespViagens) {
        return axiosJwt
            .post(
                `${api}/credenciados/fornecedores/finalizacoes/${finalizacaoDespViagens.finalizacaoId}/associardespviagens`,
                finalizacaoDespViagens
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    desassociarDespViagem(finalizacaoDespViagem) {
        return axiosJwt
            .post(
                `${api}/credenciados/fornecedores/finalizacoes/${finalizacaoDespViagem.finalizacaoId}/desassociardespviagem`,
                finalizacaoDespViagem
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(finalizacaoId) {
        return axiosJwt
            .get(
                `${api}/credenciados/fornecedores/finalizacoes/${finalizacaoId}/timeline`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
